import CloseIcon from '@/assets/icons/icon-close.svg'

interface Props<T> {
  name: string
  value: T
  disabled?: boolean
  onRemove: (id: T) => void
}

export const RemovableBadge = <T,>({
  name,
  value,
  disabled,
  onRemove,
}: Props<T>) => {
  return (
    <span
      key={name}
      className="me-2 inline-flex items-center rounded  bg-gray-100 px-2 py-1 text-sm font-medium text-gray-800 dark:bg-gray-700 dark:text-gray-300"
    >
      {name}
      {!disabled && (
        <button
          type="button"
          className="ms-2 inline-flex items-center rounded-sm bg-transparent p-1 text-sm text-gray-500 hover:text-gray-900 dark:hover:text-white"
          data-dismiss-target="#badge-dismiss-pink"
          aria-label="Remove"
        >
          <CloseIcon onClick={() => onRemove(value)} />
          <span className="sr-only">Remove badge</span>
        </button>
      )}
    </span>
  )
}
